import React, { useContext } from 'react';
import { UploadStateContext } from '@/components/upload-core/context';
import { UploadListItem } from '../upload-list-item';
import './index.scss';
export const UploadList = () => {
    const { value } = useContext(UploadStateContext);
    if (!value.length)
        return null;
    return (React.createElement("div", { className: "cn-oss-upload-list" }, value.map((item) => (React.createElement(UploadListItem, { key: item.key || item.name || item.size, file: item })))));
};
